import React from "react";

const BattingIframe = ({ detail }) => {
  return (
      <iframe
        className="responsive-iframe w-100"
        style={{
          overflowX: "hidden",
          overflow: "hidden",
          // height: "510px",
          height:'140px',
          backgroundColor: "#000000",
        }}
        id="scoreId"
        // onLoad={load}
        src={`https://fasthit.uk/skyclnt_newsw/scoreboard-widget/?id=${detail?.scoreId}&t=d`}
      ></iframe>
  );
};

export default BattingIframe;
